import React, {ReactNode} from "react"

import Flex from "@irati/ui/src/Flex"
import noData from "@irati/ui/images/noData.png"
import {H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"

interface Props {
  text?: string
  children?: ReactNode
}

const EmptyData: React.FC = (props: Props) => {
  const text = props.text || "admin.reporting.popularPerks.noData"

  return (
    <Flex alignItems="center">
      <img src={noData} alt="noData" />
      <Flex direction="column" paddingLeft={3}>
        <H3>
          <FormattedMessage id={text} />
        </H3>
        {props?.children && <Spacing marginTop={2}>{props?.children}</Spacing>}
      </Flex>
    </Flex>
  )
}

export default EmptyData
